module.exports = __webpack_public_path__ + "static/media/бо.edf519e7.mp3";